import React from 'react';
import { Link } from 'react-router-dom';

const TermsAndConditions = () => {
  return (
    <div className="policy-container">
      <Link to="/" className="action-button">Home</Link>
      <h1>Terms & Conditions</h1>
      <p>
        By downloading or using the app, these terms will automatically apply to you – you should make sure therefore that you read them carefully before using the app.
      </p>
      <p>
        You are not allowed to copy or modify the app, any part of the app, or our trademarks in any way. You are not allowed to attempt to extract the source code of the app, and you also should not try to translate the app into other languages or make derivative versions.
      </p>
      <p>
        The app itself, and all the trademarks, copyright, database rights, and other intellectual property rights related to it, still belong to Practice Capsule.
      </p>
      <p>
        Practice Capsule is committed to ensuring that the app is as useful and efficient as possible. For that reason, we reserve the right to make changes to the app or to charge for its services, at any time and for any reason.
      </p>
      <p>
        The Practice Capsule app stores and processes personal data that you have provided to us, to provide our Service. It is your responsibility to keep your phone and access to the app secure.
      </p>
    </div>
  );
};

export default TermsAndConditions;
